import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import  {Booking}  from '../booking'; // Adjust path as needed
import { checkPermission } from '../../../../core/permissons/CheckPermissons';
import apiDefinitions from '../../../../core/api/apiDefinitions';

interface PendingBookingsModalProps {
  show: boolean;
  onHide: () => void;
  pendingDetails: Booking[];
  pendingModalError: string | null;
  approveError: string | null;
  isApproving: boolean;
  handleViewClick: (booking: Booking) => void;
  handleApproveClick: (bookingId: number) => void;
  statusColors: { [key: string]: string };
}

const PendingBookingsModal: React.FC<PendingBookingsModalProps> = ({
  show,
  onHide,
  pendingDetails,
  pendingModalError,
  approveError,
  isApproving,
  handleViewClick,
  handleApproveClick,
  statusColors,
}) => {
  return (
    <Modal show={show} onHide={onHide} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Pending Booking</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {pendingModalError && !pendingDetails.length ? (
          <div className="alert alert-info">No Pending Boking Availables</div>
        ) : approveError ? (
          <div className="alert alert-danger">{approveError}</div>
        ) : isApproving ? (
          <div className="text-center">Approving...</div>
        ) : pendingDetails.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Emp Num</th>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Priority</th>
                  <th>Departure Time</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {pendingDetails.map((booking) => (
                  <tr key={booking.id}>
                    <td>{booking.id}</td>
                    <td>{booking.user?.empNumber || 'N/A'}</td>
                    <td>{booking.user?.name || 'N/A'}</td>
                    <td>
                      <span className={statusColors[booking.status] || 'badge bg-secondary'}>
                        {booking.status || 'N/A'}
                      </span>
                    </td>
                    <td>{booking.priority || 'N/A'}</td>
                    <td>
                      {booking.departureTime
                        ? new Date(Number(booking.departureTime)).toLocaleString()
                        : 'N/A'}
                    </td>
                    <td>
                      <div className="btn-group">
                        <button
                          className="btn btn-info btn-sm me-1"
                          onClick={() => handleViewClick(booking)}
                        >
                          View
                        </button>
                        <button
                          className="btn btn-success btn-sm"
                          onClick={() => handleApproveClick(booking.id)}
                          disabled={isApproving || !checkPermission('ROLE_APPROVE_VEHICLE_BOOKING')}
                          title={
                            checkPermission('ROLE_APPROVE_VEHICLE_BOOKING')
                              ? 'Approve booking'
                              : 'You lack permission to approve'
                          }
                        >
                          Approve
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>No pending bookings available.</p>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PendingBookingsModal;